import React from "react";
import FormSubmissionValues from "../../../FormBuilderInputs/FormSubmissionValues";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import { Modal } from "react-bootstrap";
import trans from "../../../../utils";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import EditAttachments from "../../../Helpers/Dropzone/EditAttachments";
import { useGetSingleFormSubmissionQuery } from "../../../../Redux/service/Forms/Form";

export default function FormSubmissionPopup({ formId, onClose }) {
  const { data: submissions } = useGetSingleFormSubmissionQuery(formId, {
    skip: !formId,
  });
  return (
    <>
      <Popup show={!!formId}>
        <Modal.Header className="modal-header flex-between ">
          <Modal.Title id="contained-modal-title-vcenter">
            <PopupTitle headtitle={`${submissions?.data?.form?.name}`} />
          </Modal.Title>
          <Close
            // eslint-disable-next-line react/style-prop-object
            style="close-32 close"
            close={() => onClose()}
            img="Close"
          />
        </Modal.Header>
        <Modal.Body
          className="modal-body-scrollable"
          style={{ height: "calc(100vh - 140px)", overflowX: "hidden" }}
        >
          <p className="fs-16 fw-500 brand-700 text-uppercase">
            {trans("Form Submission Details")}
          </p>
          <div className="row">
            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("Form Name")}
                  item={submissions?.data?.form?.name}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("Task Name")}
                  item={submissions?.data?.task?.name}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("Task Code")}
                  item={submissions?.data?.task?.code}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("POI")}
                  item={submissions?.data?.task?.poi?.name}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("Submitted At")}
                  item={formatDateString(submissions?.data?.submittedAt)}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("Submitted By")}
                  item={submissions?.data?.submittedBy?.name}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="display-border">
                <PopupBodyItem
                  title={trans("Status")}
                  item={trans(submissions?.data?.status)}
                />
              </div>
            </div>
          </div>
          <p className="fs-16 fw-500 brand-700 text-uppercase mt-2">
            {trans("Form Submission Values")}
          </p>
          <FormSubmissionValues
            formId={submissions?.data?.formId || submissions?.data?.form?.id}
            formData={submissions?.data?.formData}
          />
          {submissions?.data?.attachments?.length > 0 && (
            <>
              <p className="fs-16 fw-500 brand-700 text-uppercase mt-2">
                {trans("Form Submission Attachments")}
              </p>
              <EditAttachments
                attachments={submissions?.data?.attachments}
                viewOnly={true}
              />
            </>
          )}
        </Modal.Body>
      </Popup>
    </>
  );
}
